import HttpClient from "../../utils/http";
import { fm_portal_url } from "../constants/api_endpoints";

export const getFMPortalSurveys = (date: string) => {
  return HttpClient.get(`${fm_portal_url}choices-list`, {
    params: { date },
  });
};

export const getFMPortalNames = (choiceId: string, date: string) => {
  return HttpClient.get(`${fm_portal_url}name-list`, {
    params: { choice_id: choiceId, date },
  });
};

export const getFMPortalDetails = (
  choiceId: string,
  date: string,
  fr_name?: string
) => {
    console.log("frnmae",fr_name);
    
  return HttpClient.get(`${fm_portal_url}details`, {
    params: {
      choice_id: choiceId,
      date,
      ...(fr_name ? { fr_name: fr_name } : {}),
    },
  });
};